export function CodePlugin(tinymce: any) {
  /*
   * TODO - find a better solution for this.
   *
   * Override tinymce `code` plugin in order to change tooltip message
   */
  if (!tinymce) {
    return null;
  }
  const pluginName = "qm_code";

  const PluginManager = tinymce.util.Tools.resolve('tinymce.PluginManager');

  if (PluginManager.lookup[pluginName]) {
    // if plugin exists, don't add it again
    return null;
  }

  const register = (editor: any) => {
    // command defined in tinymce `code` plugin
    const onAction = () => editor.execCommand('mceCodeEditor');

    // same name for `addButton` as defined in the `code` plugin
    editor.ui.registry.addButton('code', {
      icon: 'sourcecode',
      text: 'Edit HTML',
      onAction
    });
    // same name for `addMenuItem` as defined in the `code` plugin
    editor.ui.registry.addMenuItem('code', {
      icon: 'sourcecode',
      text: 'Edit HTML',
      onAction
    });
  }

  PluginManager.add(pluginName, (editor: any) => { // `qm` stands for query.me
    register(editor);

    return {};
  })
}
